// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import ScrollReveal from 'stimulus-scroll-reveal';

const application = Application.start();
application.register('scroll-reveal', ScrollReveal);

window.Stimulus = application;

const context = require.context('controllers', true, /\.js$/);
// eslint-disable-next-line
Stimulus.load(definitionsFromContext(context));
